export abstract class AValidator {
  protected abstract formElement: HTMLFormElement;

  abstract getValidationFunctions(): ((
    setFieldHintCb: (errorNumber: number[], element: HTMLElement[]) => void,
  ) => void)[];
  protected abstract buildElementList(): void;
}
